/* ================================================================
   rq-tap-rescue.js

   Last resort. If a tap lands on a full-screen fixed element while
   nothing is legitimately open, that element is a stuck overlay and
   gets pointer-events:none so the page becomes usable again.

   THIS IS DELIBERATELY HARD TO TRIGGER.
   An earlier version was too eager and would have disabled two real
   lightboxes on this store - #mobile-gallery-overlay in
   main-product.liquid and #pshow-modal in product-showcase.liquid.
   Both are position:fixed, both are 100vw x 100vh, and both are
   opened with a class named 'active' that the old open-check did not
   know about. Tapping their backdrop to dismiss - the normal gesture,
   and there is always backdrop to hit - would have permanently
   disabled the overlay INCLUDING its own close button, since
   pointer-events:none on an ancestor removes descendants from hit
   testing. That would have created the exact black-sheet-eating-taps
   bug this file exists to prevent.

   So there are now three guards, and an element must fail all of
   them to be neutralised:
     1. nothing in OPEN_SELECTOR is currently open
     2. the element is position:fixed and covers >=90% of the viewport
     3. the element contains NO dialog role and NO focusable
        descendant. A real modal always has a close button; a stuck
        backdrop has nothing to click.
   ================================================================ */
(function () {
  'use strict';

  if (window.__rqTapRescue) return;
  window.__rqTapRescue = true;

  var OPEN_SELECTOR =
    'cart-drawer.active, .quick-add-modal[open], modal-dialog[open], ' +
    '.modal__content[open], details[open] > .menu-drawer, ' +
    '#mobile-gallery-overlay.active, #pshow-modal.active';

  var FOCUSABLE =
    '[role="dialog"], button, a[href], input, select, textarea, summary, [tabindex]';

  function somethingOpen() {
    return document.querySelector(OPEN_SELECTOR);
  }

  function describe(el) {
    if (!el) return '(none)';
    var cls = (el.className && el.className.toString ? el.className.toString() : '')
      .trim().split(/\s+/).slice(0, 3).join('.');
    return el.tagName.toLowerCase() + (el.id ? '#' + el.id : '') + (cls ? '.' + cls : '');
  }

  /* TouchEvent has no clientX. Reading it from touches[0] is what
     makes the touchstart path work at all. */
  function point(e) {
    var t = (e.touches && e.touches[0]) || (e.changedTouches && e.changedTouches[0]);
    if (t) return { x: t.clientX, y: t.clientY };
    if (typeof e.clientX === 'number') return { x: e.clientX, y: e.clientY };
    return null;
  }

  function rescue(e) {
    if (somethingOpen()) return;

    var p = point(e);
    if (!p) return;

    var el = document.elementFromPoint(p.x, p.y);
    if (!el || el === document.body || el === document.documentElement) return;
    if (el.getAttribute('data-rq-unblocked') === '1') return;

    /* Only a fixed element can be a stuck overlay. Page content is
       statically positioned, so content can never be caught here. */
    var cs = window.getComputedStyle(el);
    if (cs.position !== 'fixed') return;

    var r = el.getBoundingClientRect();
    var w = window.innerWidth || document.documentElement.clientWidth;
    var h = window.innerHeight || document.documentElement.clientHeight;
    if (r.width < w * 0.9 || r.height < h * 0.9) return;

    /* A real modal has something to interact with. A stuck backdrop
       does not. This is the guard that protects the lightboxes. */
    if (el.matches(FOCUSABLE) || el.querySelector(FOCUSABLE)) return;

    el.style.setProperty('pointer-events', 'none', 'important');
    el.setAttribute('data-rq-unblocked', '1');

    if (document.body.classList.contains('overflow-hidden')) {
      document.body.classList.remove('overflow-hidden');
    }

    if (window.console && console.warn) {
      console.warn('[rq-tap-rescue] unblocked a stuck full-screen overlay: ' + describe(el));
    }
  }

  document.addEventListener('touchstart', rescue, true);
  document.addEventListener('pointerdown', rescue, true);
})();
